import React from "react";
import ChatInterface from "@/components/chat/ChatInterface";

export const Chat: React.FC = () => {
  return (
    <div className="h-screen w-full flex flex-col">
      <ChatInterface autoFocus />
    </div>
  );
};
